export default __webpack_public_path__ + "assets/images/b5123c0881429d4a91dc35db7ece8044.png";